import { AuthResponse, useJWTDecode, useLocalStorage } from "@elit-hair/elit-tools";
import { ReactNode, createContext, useCallback, useContext } from "react";

import { AuthContext } from "@/types/auth";

const context = createContext<AuthContext>(null);

export const removeTokens = () => {
    localStorage.removeItem("session");
    console.log("Tokens removed");
    location.reload();
};

export const AuthProvider = ({ children }: { children: ReactNode }) => {
    const [auth, setAuth] = useLocalStorage<AuthResponse | null>("session", null);

    const userData = useJWTDecode(auth?.accessToken);

    const handleLogout = useCallback(() => {
        setAuth(null);
        // router.navigate("/", { replace: true });
    }, [setAuth]);

    return (
        <context.Provider
            value={{
                handleLogout,
                auth,
                setAuth,
                userData,
            }}
        >
            {children}
        </context.Provider>
    );
};

const useAuth = () => {
    const ctx = useContext(context);
    if (!ctx) {
        throw new Error("useAuth must be used within a AuthProvider");
    } else {
        return ctx;
    }
};

export default useAuth;
